import { Component, OnInit } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { BienService } from '../../../core/services/bien.service';
import {
  BienImmobilier,
  formatAdresse,
} from '../../../core/models/bien-immobilier.model';
import { APP_ROUTES } from '../../../core/constants/app-routes';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { SearchPipe } from '../../../core/pipes/search.pipe';

@Component({
  selector: 'app-liste-biens',
  templateUrl: './liste-biens.component.html',
  styleUrls: ['./liste-biens.component.css'],
  imports: [RouterLink, FaIconComponent, FormsModule, SearchPipe, TranslateModule],
})
export class ListeBiensComponent implements OnInit {
  biens: BienImmobilier[] = [];
  query = '';
  loading = true;
  error = false;
  readonly routes = APP_ROUTES;

  constructor(
    private readonly bienService: BienService,
    private readonly translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.bienService.findAll().subscribe({
      next: (biens) => {
        this.biens = biens ?? [];
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      },
    });
  }

  adresse(bien: BienImmobilier): string {
    return formatAdresse(bien);
  }

  unites(bien: BienImmobilier): string {
    const n = bien.nbLogementDto ?? 0;
    if (n === 0) {
      return this.translate.instant('bien.unites.none');
    }
    if (n === 1) {
      return this.translate.instant('bien.unites.one');
    }
    return this.translate.instant('bien.unites.many', { count: n });
  }
}
